import { api } from './apiClient';

export interface GSTCollected {
  cgst: number;
  sgst: number;
  igst: number;
  total: number;
}

export interface GSTSummary {
  collected: GSTCollected;
  itc: GSTCollected;
  netLiability: number;
  salesInvoiceCount: number;
  purchaseInvoiceCount: number;
}

export interface TDSSummary {
  totalDeducted: number;
  totalDeposited: number;
  pendingDeposit: number;
  deductionCount: number;
  challanCount: number;
}

export interface ComplianceScore {
  overall: number;
  gstFiling: number;
  tdsCompliance: number;
  invoiceCompleteness: number;
}

export interface ComplianceActivity {
  id: number;
  type: string;
  module: string;
  description: string;
  timestamp: string;
}

export interface ComplianceDashboard {
  period: { month: number; year: number; startDate: string; endDate: string };
  gstSummary: GSTSummary;
  tdsSummary: TDSSummary;
  complianceScore: ComplianceScore;
  recentActivities: ComplianceActivity[];
}

export const complianceService = {
  getDashboard: (params?: { month?: number; year?: number }) =>
    api.get<ComplianceDashboard>('/compliance/dashboard', { params }),

  getGSTSummary: (params?: { month?: number; year?: number }) =>
    api.get<{ gstSummary: GSTSummary }>('/compliance/gst-summary', { params }),

  getTDSSummary: (params?: { month?: number; year?: number }) =>
    api.get<{ tdsSummary: TDSSummary }>('/compliance/tds-summary', { params }),

  getScore: (params?: { month?: number; year?: number }) =>
    api.get<{ complianceScore: ComplianceScore }>('/compliance/score', { params }),

  getActivities: () =>
    api.get<{ activities: ComplianceActivity[] }>('/compliance/activities'),
};
